import {JSX} from "react";

import {Typography} from "@/shared/ui/data-display/typography";
import {FontWeight, ResponsiveSize} from "@/shared/ui/data-display/typography/typography";

interface Props {
    children?: string;

    size?: ResponsiveSize;
    weight?: FontWeight;
}
const SIZE_DEFAULT: ResponsiveSize = {desktop: 48, mobile: 32};
export function HeroTitle({children, size = SIZE_DEFAULT, weight = 500}: Props): JSX.Element {
    return <Typography className="hero__title" as="h1" size={size} weight={weight} color="white" innerHTML={children} />;
}
